import React, { useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const PasswordInput = ({ controlId, label, name, value, onChange, placeholder, required = false, autoComplete = "off" }) => {
    const { t } = useTranslation();
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <Form.Group className="mb-3" controlId={controlId}>
            {label && <Form.Label>{label}</Form.Label>}
            <InputGroup>
                <Form.Control
                    type={showPassword ? "text" : "password"}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    autoComplete={autoComplete}
                />
                <Button variant="outline-secondary" onClick={togglePasswordVisibility} aria-label={showPassword ? t('passwordInput.hide') : t('passwordInput.show')}>
                    {showPassword ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye-slash" viewBox="0 0 16 16">
                            <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5c-.466 0-.908.045-1.33.124L11.27 5.67c.292.111.556.266.794.456.764.646 1.31 1.398 1.667 2.188.307.742.354 1.274.354 1.274zM8 5.5c-1.653 0-2.94.93-3.5 2.214l-.763-.762A13.144 13.144 0 0 1 0 8s3 5.5 8 5.5c.936 0 1.81-.109 2.61-.307l-1.781-1.782c-.212.07-.43.145-.65.223-.547.194-1.248.36-2.01.36-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8c.12-.17.25-.34.39-.51l-.762-.762zm2.5 1.472L5.527 10.47c.18.035.36.058.543.058 1.723 0 3.153-1.292 3.585-3.153z"/>
                            <path d="M14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-.773 0-1.5-.165-2.16-.44l.762-.762c.52.16.99.28 1.478.28 2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 1 14.828 8z"/>
                            <path d="M.646 13.354 13.354.646 14.354 1.646.646 14.354z"/>
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13.134 13.134 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                        </svg>
                    )}
                </Button>
            </InputGroup>
        </Form.Group>
    );
};

export default PasswordInput;
